export enum SignupTypeEnum {
  AUTO_CANCELLED = "AUTO_CANCELLED",
  ENROLLED = "ENROLLED",
  PURCHASE_HOLD = "PURCHASE_HOLD",
  UNENROLLED = "UNENROLLED",
  WAITLISTED = "WAITLISTED",
}
